import { put, takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { crudSaga, querySaga } from '../../../utils/reduxHelper';

const configOpiton = window && window.config;

function* resetMessageSaga() {
    yield put(appActions.MESSAGE_RESET_SUCCESS());
}

function* resetTopicSaga() {
    yield put(appActions.TOPIC_RESET_SUCCESS());
}

function* watchMessageGetAllRequest() {
    yield takeLatest(
        appActions.MESSAGE_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                `${configOpiton?.END_POINT}/communication/v1/message-exchange/wsmsg`,
                appActions.MESSAGE_GET_ALL_SUCCESS,
                appActions.MESSAGE_GET_ALL_FAILURE,
            );
        },
    );
}

function* watchTopicGetRequest() {
    yield takeLatest(
        appActions.TOPIC_GET_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                `communication/v1/user-topic/topic/${action.payload.chatId}`,
                appActions.TOPIC_GET_SUCCESS,
                appActions.TOPIC_GET_FAILURE,
            );
        },
    );
}

function* watchTopicCreateRequest() {
    yield takeLatest(
        appActions.TOPIC_CREATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/communication/v1/user-topic/save',
                appActions.TOPIC_CREATE_SUCCESS,
                appActions.TOPIC_CREATE_FAILURE,
                'POST',
            );
        },
    );
}

export default function* messageWatcher() {
    yield* watchMessageGetAllRequest();
    yield* watchTopicGetRequest();
    yield* watchTopicCreateRequest();
    yield takeLatest(appActions.MESSAGE_RESET_REQUEST.type, resetMessageSaga);
    yield takeLatest(appActions.TOPIC_RESET_REQUEST.type, resetTopicSaga);
    // Add other watchers here
}
